import { saveAs } from 'file-saver';
import { formatCentsToUsd } from '../../../helpers/formatCentsToUsd';

export const exportPayoutReportToXlsx = async (reportData, dateFrom, dateTo) => {
    const XLSX = await import('xlsx');
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const formatDateLabel = (value) => {
        if (!value) return null;
        const parsed = new Date(`${value}T12:00:00`);
        return Number.isNaN(parsed.getTime()) ? null : parsed.toLocaleDateString();
    };
    const fromLabel = formatDateLabel(dateFrom);
    const toLabel = formatDateLabel(dateTo);
    const rangeLabel =
        fromLabel && toLabel ? `${fromLabel} - ${toLabel}` : fromLabel || toLabel || 'All dates';

    const { summary, excluded, transactions = [] } = reportData;

    const sheetData = [
        ['Payout Report'],
        [`Date Range: ${rangeLabel}`],
        ['Total Amount:', formatCentsToUsd(summary.totalAmount)],
        ['Processing Fees:', formatCentsToUsd(summary.processingFees)],
        ['Booking Fees - Total', formatCentsToUsd(summary.bookingFeesTotal)],
        ['Booking Fees - Venue rebate', formatCentsToUsd(summary.bookingFeesVenueRebate)],
        ['Booking Fees - Fireknife', formatCentsToUsd(summary.bookingFeesFireknife)],
        ['Net to Venue', formatCentsToUsd(summary.netToVenue)],
        [
            `Excluded affiliate revenue: ${formatCentsToUsd(excluded.affiliateRevenue)} across ${excluded.affiliateBookingCount} bookings`,
        ],
        [],
        [
            'Booking ID',
            'Booking Status',
            'Show',
            'Contact',
            'Email',
            'Voucher',
            'Customers',
            'Show Date',
            'Source',
            'Order ID',
            'Transaction ID',
            'Order Status',
            'Transaction Status',
            'Payment Type',
            'Transaction Date',
            'Transaction Amount',
            'Processing Fee',
            'Booking Fee',
            'Venue Rebate',
            'Fireknife Fee',
        ],
        ...transactions.map((r) => [
            r.bookingId,
            r.bookingStatus,
            r.show,
            r.contact,
            r.email,
            r.voucher,
            r.customers,
            r.showDate,
            r.commissionGroups && r.commissionGroups.length
                ? r.commissionGroups.join(', ')
                : r.source,
            r.orderId,
            r.transactionId,
            r.orderStatus,
            r.transactionStatus,
            r.paymentType,
            r.transactionDate,
            formatCentsToUsd(r.amount),
            formatCentsToUsd(r.processingFee),
            formatCentsToUsd(r.bookingFee),
            formatCentsToUsd(r.venueRebate),
            formatCentsToUsd(r.fireknifeFee),
        ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!cols'] = [
        { wch: 10 }, // Booking ID
        { wch: 14 }, // Booking Status
        { wch: 22 }, // Show
        { wch: 20 }, // Contact
        { wch: 24 }, // Email
        { wch: 12 }, // Voucher
        { wch: 24 }, // Customers
        { wch: 18 }, // Show Date
        { wch: 16 }, // Source
        { wch: 10 }, // Order ID
        { wch: 12 }, // Transaction ID
        { wch: 12 }, // Order Status
        { wch: 14 }, // Transaction Status
        { wch: 12 }, // Payment Type
        { wch: 22 }, // Transaction Date
        { wch: 16 }, // Transaction Amount
        { wch: 14 }, // Processing Fee
        { wch: 12 }, // Booking Fee
        { wch: 12 }, // Venue Rebate
        { wch: 13 }, // Fireknife Fee
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payout Report');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });

    const filenameRange =
        dateFrom && dateTo ? `${dateFrom}-to-${dateTo}` : dateFrom || dateTo || 'all-dates';
    saveAs(file, `payout-report-${filenameRange}${fileExtension}`);
};

export default exportPayoutReportToXlsx;
